module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"請輸入您的資訊。","submit":"尋找尺寸","height":{"labelName":"身高","labelUnit":"cm","placeholder":"身高","error":"請輸入 130 到 210 之間的數字。"},"weight":{"labelName":"體重","labelUnit":"kg","placeholder":"體重","error":"請輸入 20 到 150 之間的數字。"},"preferred_fit":{"title":"您想以什麼版型穿這件衣服？","options":{"slim":"修身版型 - 貼合身體的緊身版型","basic":"基本版型 - 忠於基本的標準版型","loose":"寬鬆版型 - 寬裕舒適的版型"}}}}')
  delete Component.options._Ctor
}
